var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoorGarage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke-width:1.5px;}.a,.c{stroke:#353841;}.b{fill:#353841;}.c,.e{fill:none;}.c{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20.185)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.064 10.098)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.294,19.715H24.642a.688.688,0,0,1-.687-.688V17.369H22.422l.094,0c-.126-2.861-2.107-3.132-2.127-3.135s-3.676-.009-6.69-.009c-1.762,0-2.958,0-3.554.009-1.9.019-2.148,2.818-2.171,3.137H6.557v1.659a.688.688,0,0,1-.687.688H3.218a.688.688,0,0,1-.687-.688V9.583A1.422,1.422,0,0,1,3.545,8.215a.849.849,0,0,1-.007-.1H.755a.614.614,0,0,1-.544-.376,2.744,2.744,0,0,1,0-2.115.616.616,0,0,1,.544-.375H3.543a.621.621,0,0,1,.545.375,3.832,3.832,0,0,1,.193.77c1.031-1.985,2.2-4.245,2.575-4.972l.01-.018A1.108,1.108,0,0,1,7.711.685a41.9,41.9,0,0,1,15.09,0,1.114,1.114,0,0,1,.846.716c.01.02,1.337,2.591,2.584,4.99a3.824,3.824,0,0,1,.194-.769.614.614,0,0,1,.544-.376h2.788a.621.621,0,0,1,.545.376,2.75,2.75,0,0,1,0,2.114.619.619,0,0,1-.545.375H26.974c0,.036,0,.068-.006.1a1.432,1.432,0,0,1,1.014,1.371v9.445A.688.688,0,0,1,27.294,19.715ZM23.861,9.97a12.754,12.754,0,0,0-2.147.233c-1.359.146-1.595,2.08-1.6,2.1h5.008c.008-.015.84-1.583,0-2.1A2.548,2.548,0,0,0,23.861,9.97Zm-16.982,0a2.541,2.541,0,0,0-1.263.233c-.84.516-.009,2.084,0,2.1h5.007c-.025-.2-.277-1.958-1.6-2.1A12.548,12.548,0,0,0,6.879,9.97Zm8.357-8.53a46.22,46.22,0,0,0-6.776.588L5.777,7.667H24.693L22.065,2.028A46.849,46.849,0,0,0,15.235,1.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1531.957,7869.386s.155-2.446,1.6-2.479,10.083,0,10.083,0,1.456.2,1.573,2.479C1543.28,7869.4,1531.957,7869.386,1531.957,7869.386Z",
    transform: "translate(-1523.338 -7852.062)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6343.826,9249.405V9220.7H6309.3",
    transform: "translate(-6309.301 -9220.698)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorGarage);
export default __webpack_public_path__ + "static/media/outdoor_garage.2fda83c31968228508d01dd2af4d961a.svg";
export { ForwardRef as ReactComponent };